import {SearchSlotComponent} from '../search-slot/search-slot.component';
import {Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {DacklExplicitSearchComponent} from '@datev/ngx-dackl';
import {TranslatePipe} from '@ngx-translate/core';


@Component({
    selector: 'myupdates-search-slot-slim',
    templateUrl: './search-slot-slim.component.html',
    styleUrls: ['./search-slot-slim.component.scss'],
  imports: [FormsModule, DacklExplicitSearchComponent, TranslatePipe]
})
export class SearchSlotSlimComponent extends SearchSlotComponent {

  onSearchTermChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.dacklSearch.searchString.set(target.value);
  }

}
